import styled from "styled-components";

export const Wrapper = styled.div`
    background: var(--color-white);
    border-radius: 52px;
    box-shadow: var(--dropdown-box-shadow);
    display: flex;
    flex-direction: row;
    gap: 16px;
    padding: 24px;
    padding-right: 72px;
    position: absolute;
    right: 0;
    top: 80vh;
`;

export const Container = styled.div`
    max-width: 1248px;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: var(--z-index-hamburger);
`;

export const Picture = styled.div`
    border-radius: 100px;
    cursor: pointer;
    overflow: hidden;
`;

export const LinkText = styled.p`
    color: var(--color-orange-60);
    cursor: pointer;
    font-weight: var(--font-weight-extra-bold);
`;

export const RecruiterCardContactFormWrapper = styled.div`
    color: var(--color-black);
`;
